import UserClassificationsContainer from './UserClassifications.container';
export default UserClassificationsContainer;